// extracted by mini-css-extract-plugin
export default {"drawerContainer":"NewPaletteForm_drawerContainer__eYmcB","drawerButtons":"NewPaletteForm_drawerButtons__bQn4s"};